import React from 'react';
import styled from 'styled-components';

import { ReactIcon } from '@metservicedev/met-ui/react-icon';
import { IconNamesLegacyUnion } from '@metservicedev/met-ui/icons-legacy';

const IconButtonStyled = styled.div<{ type: string; darkTheme: boolean }>`
    border-radius: 4px;
    ${({ type }) => {
        if (type === 'primary') return 'background-color: #7599ff;';
        return 'background-color: inherit;';
    }}
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ type }) => {
        if (type === 'primary') return 'color: white;';
        return 'color: black;';
    }}
    font-size: 20px;

    :hover {
        cursor: pointer;
        ${({ type, darkTheme }) => {
            if (type === 'primary') return 'background-color: #577CE7;';
            if (type === 'blank' && darkTheme) return 'background-color: #444;';
            if (type === 'blank') return 'background-color: darkgrey;';
            return 'background-color: inherit;';
        }}
    }

    color: ${({ darkTheme }) => (darkTheme ? 'white' : 'black')};
`;

interface IconButtonProps {
    metuiIcon?: IconNamesLegacyUnion;
    CustomIcon?: React.FC;
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    type?: 'primary' | 'blank';
    darkTheme?: boolean;
}
export const IconButton = ({ CustomIcon, onClick, type = 'primary', darkTheme, metuiIcon }: IconButtonProps) => {
    return (
        <IconButtonStyled onClick={onClick} type={type} darkTheme={darkTheme ?? false}>
            {metuiIcon && <ReactIcon name={metuiIcon} size={16} />}
            {metuiIcon || (CustomIcon && <CustomIcon />)}
        </IconButtonStyled>
    );
};
